// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__KNeqP","empty":"ModalGraph_empty__UcqHi"};